window.ttx = window.ttx || {};
ttx.toast = {};

ttx.toast._instances = [];
ttx.toast._seed = 1;

/** 错误 toast 是否显示复制按钮，默认 true，设为 false 可全局关闭 */
ttx.toast.errorCopyEnabled = true;

ttx.toast._defaultOptions = {
    type: 'info',
    content: '',
    duration: 3000,
    position: 'top-right',
    offset: 16,
    gap: 8,
    zIndex: 6000,
    closable: false,
    onClose: null
};

ttx.toast._mergeOptions = function (options) {
    return { ...ttx.toast._defaultOptions, ...(options || {}) };
};

ttx.toast._calculateTopOffset = function () {
    const visibleInstances = ttx.toast._instances.filter(function (id) {
        return id && typeof id.close === 'function';
    });
    
    if (visibleInstances.length === 0) {
        return ttx.toast._defaultOptions.offset;
    }
    
    let totalHeight = ttx.toast._defaultOptions.offset;
    visibleInstances.forEach(function (instance) {
        const element = document.getElementById(instance.id);
        if (element) {
            totalHeight += element.offsetHeight + ttx.toast._defaultOptions.gap;
        } else {
            totalHeight += 52 + ttx.toast._defaultOptions.gap;
        }
    });
    
    return totalHeight;
};

ttx.toast._create = function (options) {
    const opts = ttx.toast._mergeOptions(options);
    
    const iconMap = {
        success: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 7L10 17L5 12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        error: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
        warning: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 7V13" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="17" r="1.2" fill="currentColor"/></svg>',
        info: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M12 10V16" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="7.5" r="1.2" fill="currentColor"/></svg>'
    };
    
    const colorMap = {
        success: '#52c41a',
        error: '#ff4d4f',
        warning: '#faad14',
        info: '#1677ff'
    };


    const id = 'tx-toast-' + ttx.toast._seed++;
    
    const topOffset = ttx.toast._calculateTopOffset();
    
    const container = document.createElement('div');
    container.id = id;
    container.style.cssText = `
        position: fixed;
        top: ${topOffset}px;
        right: ${opts.offset}px;
        max-width: 300px;
        min-width: 100px;
        padding: 10px 16px;
        background: #fff;
        border-radius: 4px;
        border: 1px solid ${colorMap[opts.type]};
        box-shadow: 0 6px 24px rgba(0,0,0,.12), 0 2px 8px rgba(0,0,0,.08);
        z-index: ${opts.zIndex};
        display: flex;
        align-items: center;
        gap: 12px;
        animation: tx-toast-slide-in 0.3s ease-out;
        overflow: hidden;
    `;
    
    const iconColor = colorMap[opts.type] || colorMap.info;
    
    const icon = document.createElement('div');
    icon.innerHTML = iconMap[opts.type] || iconMap.info;
    icon.style.cssText = `
        width: 20px;
        height: 20px;
        min-width: 20px;
        border-radius: 50%;
        color: ${iconColor};
        background: ${iconColor}1a;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 1px;
    `;
    const iconSvg = icon.firstElementChild;
    if (iconSvg) {
        iconSvg.style.width = '14px';
        iconSvg.style.height = '14px';
        iconSvg.style.display = 'block';
    }

    const progress = document.createElement('div');
    progress.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: linear-gradient(90deg, ${colorMap[opts.type]} 0%, ${colorMap[opts.type]}99 100%);
        transform-origin: left center;
        animation: tx-toast-progress ${opts.duration}ms linear forwards;
        will-change: transform;
    `;
    
    const content = document.createElement('div');
    content.style.cssText = `
        flex: 1;
        font-size: 14px;
        color: #333;
        line-height: 1.5;
        word-break: break-word;
        white-space: normal;
        overflow-wrap: break-word;
        min-width: 0;
    `;

    var copyBtn = null;
    if (opts.errorData) {
        var ed = opts.errorData;
        var codeStr = ed.code ? '[' + ed.code + '] ' : '';
        content.innerHTML =
            '<div style="margin-bottom:2px;word-break:break-word">' +
                '<span style="font-weight:600">' + codeStr + '</span>' +
                '<span>' + ed.message + '</span>' +
            '</div>' +
            '<div style="display:flex;align-items:center;justify-content:space-between">' +
                '<span style="font-size:12px;color:#999">' + ed.time + '</span>' +
            '</div>';

        // 复制按钮
        var showCopy = opts.errorData.copyEnabled !== undefined ? opts.errorData.copyEnabled : ttx.toast.errorCopyEnabled;
        if (showCopy) {
            var copyText = (codeStr + ed.message + '\n' + ed.time).replace(/<[^>]*>/g, '');
            copyBtn = document.createElement('button');
            copyBtn.type = 'button';
            copyBtn.title = '复制错误信息';
            copyBtn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
            copyBtn.style.cssText = `
                width: 24px;
                height: 24px;
                border: none;
                background: transparent;
                cursor: pointer;
                color: #999;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                flex-shrink: 0;
            `;
            copyBtn.addEventListener('mouseenter', function () {
                copyBtn.style.color = '#333';
                copyBtn.style.background = '#f5f5f5';
            });
            copyBtn.addEventListener('mouseleave', function () {
                copyBtn.style.color = '#999';
                copyBtn.style.background = 'transparent';
            });
            copyBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(copyText).then(function () {
                        copyBtn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#52c41a" stroke-width="2"><path d="M20 7L10 17L5 12"/></svg>';
                        setTimeout(function () {
                            copyBtn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
                        }, 1500);
                    }).catch(function () {
                        // fallback
                        var ta = document.createElement('textarea');
                        ta.value = copyText;
                        ta.style.position = 'fixed';
                        ta.style.left = '-9999px';
                        document.body.appendChild(ta);
                        ta.select();
                        document.execCommand('copy');
                        document.body.removeChild(ta);
                    });
                }
            });
            // 把复制按钮塞进时间那一行
            var timeRow = content.querySelector('div:last-child');
            if (timeRow) timeRow.appendChild(copyBtn);
        }

        // 查看详情按钮（错误对象新规范：showDetail 为 true 时显示）
        if (opts.errorData.showDetail && typeof opts.errorData.onShowDetail === 'function') {
            var detailBtn = document.createElement('button');
            detailBtn.type = 'button';
            detailBtn.textContent = '查看详情';
            detailBtn.style.cssText = `
                height: 22px;
                padding: 0 8px;
                border: 1px solid #d9d9d9;
                background: #fff;
                color: #333;
                cursor: pointer;
                border-radius: 4px;
                font-size: 12px;
                margin-left: 8px;
                flex-shrink: 0;
            `;
            detailBtn.addEventListener('mouseenter', function () {
                detailBtn.style.color = ttx.modal ? (ttx.modal._getAccentColor ? ttx.modal._getAccentColor() : '#165dff') : '#165dff';
                detailBtn.style.borderColor = detailBtn.style.color;
            });
            detailBtn.addEventListener('mouseleave', function () {
                detailBtn.style.color = '#333';
                detailBtn.style.borderColor = '#d9d9d9';
            });
            detailBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                opts.errorData.onShowDetail();
            });
            var detailRow = content.querySelector('div:last-child');
            if (detailRow) detailRow.appendChild(detailBtn);
        }
    } else {
        content.textContent = opts.content;
    }

    if (opts.closable) {
        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '×';
        closeBtn.type = 'button';
        closeBtn.style.cssText = `
            width: 20px;
            height: 20px;
            border: none;
            background: transparent;
            cursor: pointer;
            font-size: 18px;
            color: #999;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
        `;
        closeBtn.addEventListener('mouseenter', function () {
            closeBtn.style.color = '#333';
            closeBtn.style.background = '#f5f5f5';
        });
        closeBtn.addEventListener('mouseleave', function () {
            closeBtn.style.color = '#999';
            closeBtn.style.background = 'transparent';
        });
        closeBtn.addEventListener('click', function () {
            close(id, 'manual');
        });
        container.appendChild(progress);
        container.appendChild(icon);
        container.appendChild(content);
        container.appendChild(closeBtn);
    } else {
        container.appendChild(progress);
        container.appendChild(icon);
        container.appendChild(content);
    }
    
    document.body.appendChild(container);
    
    let timer = null;
    let closed = false;
    let remaining = opts.duration > 0 ? opts.duration : 0;
    let startAt = 0;
    let progressEl = progress;

    const startTimer = function () {
        if (remaining <= 0) {
            close('timeout');
            return;
        }
        startAt = Date.now();
        // 重启进度条：先清掉旧动画，用 transition 替代 animation 避免负 delay 闪烁
        const pct = (1 - remaining / opts.duration) * 100;
        progressEl.style.animation = 'none';
        progressEl.style.transform = `scaleX(${pct / 100})`;
        progressEl.style.transition = 'none';
        // 强制 reflow 确保上两行生效
        void progressEl.offsetHeight;
        progressEl.style.transition = `transform ${remaining}ms linear`;
        progressEl.style.transform = 'scaleX(1)';
        timer = setTimeout(function () {
            close('timeout');
        }, remaining);
    };

    const pauseTimer = function () {
        if (!timer) return;
        clearTimeout(timer);
        timer = null;
        remaining -= Date.now() - startAt;
        if (remaining < 0) remaining = 0;
        // 定格进度条当前位置
        const pct = (1 - remaining / opts.duration) * 100;
        progressEl.style.transition = 'none';
        progressEl.style.transform = `scaleX(${pct / 100})`;
    };

    const onMouseEnter = function () {
        pauseTimer();
    };

    const onMouseLeave = function () {
        if (closed) return;
        startTimer();
    };

    const close = function (trigger) {
        if (closed) return;
        closed = true;

        container.removeEventListener('mouseenter', onMouseEnter);
        container.removeEventListener('mouseleave', onMouseLeave);

        if (timer) {
            clearTimeout(timer);
            timer = null;
        }

        // 先停掉进度条，避免和 fade-out 动画冲突造成卡顿
        progressEl.style.transition = 'none';
        progressEl.style.animation = 'none';

        container.style.animation = 'tx-toast-fade-out 0.2s ease-in';

        setTimeout(function () {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
            }
            const index = ttx.toast._instances.indexOf(instance);
            if (index > -1) {
                ttx.toast._instances.splice(index, 1);
            }
            if (typeof opts.onClose === 'function') {
                opts.onClose(trigger);
            }
        }, 200);
    };

    if (opts.duration > 0) {
        container.addEventListener('mouseenter', onMouseEnter);
        container.addEventListener('mouseleave', onMouseLeave);
        startTimer();
    }
    
    const instance = {
        id,
        close,
        element: container
    };
    
    ttx.toast._instances.push(instance);
    
    return {
        id,
        close,
        element: container
    };
};

ttx.toast.show = function (options) {
    return ttx.toast._create(options);
};

ttx.toast.success = function (content, options) {
    return ttx.toast._create({
        ...options,
        type: 'success',
        content
    });
};

/**
 * 判断是否为错误对象新规范（含 displayCode/detailMsg/level 等字段）
 * @param {any} obj
 * @returns {boolean}
 */
ttx.toast._isErrorObj = function (obj) {
    return obj && typeof obj === 'object' && (obj.displayCode || obj.detailMsg || obj.level !== undefined);
};

/**
 * 错误级别映射到 toast 类型
 * level: 0 → error，1 → warning，2 → confirm（toast 无 confirm，用 info）
 * @param {number} level
 * @returns {string}
 */
ttx.toast._levelToType = function (level) {
    if (level === 1) return 'warning';
    if (level === 2) return 'info';
    return 'error';
};

ttx.toast.error = function (content, options) {
    var opts = options || {};
    var toastType = 'error';

    // 错误对象新规范（displayCode/detailMsg/level/showDetail 等）
    if (ttx.toast._isErrorObj(content)) {
        toastType = ttx.toast._levelToType(content.level);
        var displayCode = content.displayCode || content.code || '';
        var detailMsg = content.detailMsg || content.message || '请求失败';
        var timeStr = content.time || (ttx.date ? ttx.date.format(new Date()) : new Date().toLocaleString());
        // showDetail：优先取错误对象自身，其次取 options.showDetail
        var showDetail = content.showDetail !== undefined ? content.showDetail : (!!opts.showDetail);
        opts.errorData = {
            code: displayCode,
            message: detailMsg,
            time: timeStr,
            httpStatus: content.httpStatus,
            showDetail: showDetail,
            copyEnabled: content.copyEnabled,
            onShowDetail: function () {
                if (ttx.modal && typeof ttx.modal.showErrorDetail === 'function') {
                    ttx.modal.showErrorDetail(content);
                }
            }
        };
        opts.content = detailMsg;
    } else if (content && typeof content === 'object') {
        // 兼容旧错误对象格式（code/message/time/httpStatus）
        opts.errorData = {
            code: content.code,
            message: content.message || '请求失败',
            time: content.time || (ttx.date ? ttx.date.format(new Date()) : new Date().toLocaleString()),
            httpStatus: content.httpStatus
        };
        opts.content = opts.errorData.message;
    } else {
        opts.content = content;
    }

    return ttx.toast._create({
        ...opts,
        type: toastType
    });
};

ttx.toast.warning = function (content, options) {
    return ttx.toast._create({
        ...options,
        type: 'warning',
        content
    });
};

ttx.toast.info = function (content, options) {
    return ttx.toast._create({
        ...options,
        type: 'info',
        content
    });
};

/**
 * 询问提示（询问对话框）
 * 对应 MDF cb.utils.confirm
 *
 * 重载：
 *   1) confirm(content, okCb, cancelCb) — 简单询问
 *   2) confirm(options) — 自定义按钮版本
 *      options: { title, content, iconType, actions: [{text, type, onPress}] }
 *      actions 为自定义按钮数组，type 可为 'primary'
 *
 * @returns {Promise<boolean|any>} 确认返回 true（或 actions.onPress 返回值），取消返回 false
 */
ttx.toast.confirm = function (content, okCb, cancelCb) {
    // 重载：confirm(options) 自定义按钮版本
    if (content && typeof content === 'object' && !Array.isArray(content)) {
        var opts = content;
        var actions = opts.actions || [];
        // 无自定义按钮时退化为标准 confirm
        if (!actions.length) {
            return ttx.modal.confirm({
                title: opts.title,
                content: opts.content,
                iconType: opts.iconType
            });
        }
        // 自定义按钮：构建内容 + 按钮区
        return new Promise(function (resolve) {
            var wrapper = document.createElement('div');
            wrapper.style.cssText = 'padding:0;';
            var msg = document.createElement('div');
            msg.style.cssText = 'margin-bottom:16px;color:#333;line-height:1.6;white-space:pre-wrap;';
            msg.textContent = opts.content == null ? '' : String(opts.content);
            wrapper.appendChild(msg);

            var footer = document.createElement('div');
            footer.style.cssText = 'display:flex;justify-content:flex-end;gap:8px;';
            var accentColor = (ttx.modal && typeof ttx.modal._getAccentColor === 'function')
                ? ttx.modal._getAccentColor()
                : '#165dff';
            actions.forEach(function (action) {
                var btn = document.createElement('button');
                btn.type = 'button';
                btn.textContent = action.text || '按钮';
                var isPrimary = action.type === 'primary';
                btn.style.cssText = isPrimary
                    ? 'height:32px;padding:0 14px;border:1px solid ' + accentColor + ';background:' + accentColor + ';color:#fff;border-radius:4px;cursor:pointer;'
                    : 'height:32px;padding:0 14px;border:1px solid #d9d9d9;background:#fff;color:#333;border-radius:4px;cursor:pointer;';
                btn.addEventListener('click', function () {
                    if (typeof action.onPress === 'function') {
                        var ret = action.onPress();
                        resolve(ret !== undefined ? ret : true);
                    } else {
                        resolve(true);
                    }
                });
                footer.appendChild(btn);
            });
            wrapper.appendChild(footer);

            ttx.modal._create({
                title: opts.title || '提示',
                content: wrapper,
                width: opts.width || 420,
                showFooter: false,
                showCancel: false,
                onClose: function (trigger) {
                    if (trigger !== 'confirm') resolve(false);
                }
            });
        });
    }

    // 简单询问：confirm(content, okCb, cancelCb)
    return new Promise(function (resolve) {
        ttx.modal.confirm({
            content: content,
            onConfirm: function () {
                if (typeof okCb === 'function') okCb();
                resolve(true);
            },
            onCancel: function () {
                if (typeof cancelCb === 'function') cancelCb();
                resolve(false);
            }
        });
    });
};

/**
 * 轻提示增强版
 * 对应 MDF cb.utils.alert 的 toast 形式
 *
 * options: { title, type('success'/'error'/'warning'/'info'/'noIcon'), duration(秒), mask, onClose }
 * 兼容直接传字符串：toast('提示内容')
 *
 * @returns {object} toast 实例
 */
ttx.toast.toast = function (options) {
    var opts = options;
    if (typeof options === 'string') {
        opts = { content: options };
    }
    opts = opts || {};
    // type='noIcon' 时不显示图标（退化为 info，因底层 _create 始终渲染图标）
    var type = opts.type;
    if (type === 'noIcon') {
        type = 'info';
    }
    // duration 单位为秒，转毫秒；默认 3 秒
    var durationMs = opts.duration !== undefined ? (Number(opts.duration) * 1000) : 3000;
    if (isNaN(durationMs) || durationMs < 0) durationMs = 3000;
    return ttx.toast._create({
        type: type || 'info',
        content: opts.title != null ? opts.title : opts.content,
        duration: durationMs,
        closable: false,
        onClose: opts.onClose
    });
};

ttx.toast.close = function (id) {
    if (!id) return;
    const instance = ttx.toast._instances.find(function (item) {
        return item && item.id === id;
    });
    if (instance && typeof instance.close === 'function') {
        instance.close();
    }
};

ttx.toast.closeAll = function () {
    const instances = ttx.toast._instances.slice();
    instances.forEach(function (instance) {
        if (instance && typeof instance.close === 'function') {
            instance.close();
        }
    });
};

if (typeof document !== 'undefined') {
    const style = document.createElement('style');
    style.textContent = `
        @keyframes tx-toast-slide-in {
            from {
                transform: translateX(100%);
                opacity: 0;
            }
            to {
                transform: translateX(0);
                opacity: 1;
            }
        }

        @keyframes tx-toast-progress {
            from {
                transform: scaleX(0);
            }
            to {
                transform: scaleX(1);
            }
        }

        @keyframes tx-toast-fade-out {
            from {
                transform: translateX(0);
                opacity: 1;
            }
            to {
                transform: translateX(100%);
                opacity: 0;
            }
        }
    `;
    document.head.appendChild(style);
}